/**
 * @module components/LegendSetting/SeriesSortBy
 * @description 图例系列排序 — UI 复用 SortByPanel，状态由 useSeriesSortDraft 管理
 */

import React from 'react';
import SortByPanel from '../common/SortByPanel';
import { useSeriesSortDraft } from './useSeriesSortDraft';

const SeriesSortBy: React.FC = () => {
  const viewModel = useSeriesSortDraft();
  return <SortByPanel {...viewModel} />;
};

export default React.memo(SeriesSortBy);
